export const versionInfo = {
  gitTag: 'v-1.3.0',
  tag: 'v-1.3.0',
  commitsAhead: '0',
  buildDate: 'Tue, 15 Sep 2026 09:10:25 GMT'
};
